import { useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ReportingYearProvider } from "./context/ReportingYearContext";

/* CUSTOMER LOGIN */
import LoginPage from "./pages/LoginPage";

/* RESET PASSWORD */
import ResetPasswordPage from "./pages/ResetPasswordPage";

/* DASHBOARD */
import DashboardPage from "./features/dashboard/DashboardPage";
import DashboardHome from "./features/dashboard/DashboardHome";

/* ORGANIZATION */
import OrganizationProfilePage from "./features/organization/organizationProfile/OrganizationProfilePage";
import DepartmentPage from "./features/organization/department/DepartmentPage";
import LegalEntitiesPage from "./features/organization/legalEntities/LegalEntitiesPage";

import EntityFormPage from "./features/organization/legalEntities/EntityFormPage";

import SitesLocationsPage from "./features/organization/sitesLocations/SiteLocationsPage";
import ManageReportingYear from "./features/organization/ManageReportingYear/ManageReportingYear";
import LocationMapping from "./features/OrganizationSettings/LocationMapping/LocationMappingPage";
import ActivityMapping from "./features/OrganizationSettings/ActivityMapping/ActivityMappingPage";
import EnvironmentalParametersPage from "./features/organization/EnvironmentalParameters/EnvironmentalParametersPage";
import ParameterMappingPage from "./features/organization/ParameterMapping/ParameterMappingPage";

/* BRSR */
import PrincipleDashboardPage from "./features/brsr/principleDashboard/PrincipleDashboardPage";
import PrincipleViewPage from "./features/brsr/principleView/PrincipleViewPage";
import PrincipleFormPage from "./features/brsr/principleDetails/PrincipleFormPage";

/* ENVIRONMENT */
import Scope1EmissionPage from "./features/environment/scope1Emission/Scope1EmissionPage";
import Scope2EmissionPage from "./features/environment/scope2Emission/Scope2EmissionPage";
import EnvironmentalSummaryPage from "./features/environment/environmentalSummary/EnvironmentalSummaryPage";
import EnergyConsumptionPage from "./features/environment/energyConsumption/EnergyConsumptionPage";
//import RecordActivity from "./features/environment/energyConsumption/EnergyConsumptionForm";
import ActivityRecordsPage from "./features/environment/ActivityRecordsPage";
import RecordActivityPage from "./features/environment/RecordActivityPage";
import EditActivityPage from "./features/environment/EditActivityPage";
import ViewActivityPage from "./features/environment/ViewActivityPage";
import Scope1ActivityListing from "./features/environment/ActivityListing/Scope1ActivityListing";
import Scope2ActivityListing from "./features/environment/ActivityListing/Scope2ActivityListing";
import EnergyBreakdownListing from "./features/environment/ActivityListing/EnergyBreakdownListing";
import EmissionIntensityListing from "./features/environment/ActivityListing/EmissionIntesityListing";
import Import from "./features/environment/import/Import";
import ImportSummary from "./features/environment/import/ImportSummary";
import ImportReferencePage from "./features/environment/import/ImportReferencePage";
import WaterSummaryPage from "./features/environment/waterSummary/WaterSummaryPage";
import WaterRecycledDetails from "./features/environment/waterSummary/waterPages/WaterRecycledDetails";
import WaterSourceDetails from "./features/environment/waterSummary/waterPages/WaterSourceDetails";
import RecyclingRateDetails from "./features/environment/waterSummary/waterPages/RecyclingRateDetails";
import NetFreshwaterDetails from "./features/environment/waterSummary/waterPages/NetFreshwaterDetails";
import EffluentDischargeDetails from "./features/environment/waterSummary/waterPages/EffluentDischargeDetails";
import WasteSummaryPage from "./features/environment/wasteSummary/WasteSummaryPage";
/* Workflow and Approvals */
import SubmissionTracker from "./features/workflow/SubmissionTracker/SubmissionTracker";
import ReviewScreen from "./features/workflow/ReviewScreen/ReviewScreen";
import ApprovalLock from "./features/workflow/AprovalLock/ApprovalLock";
import ViewAction from "./features/workflow/SubmissionActions/ViewAction";

/* DISCLOSURE GENERATOR */
import DisclosureBuilder from "./features/disclouser/DisclouserBuilder/DisclouserBuilder";
import ExportScreen from "./features/disclouser/ExportScreen/ExportScreen";
import GeneralDisclosuresPage from "./features/disclouser/sectionA/GeneralDisclosuresPage";
import ProcessDisclosuresPage from "./features/disclouser/sectionB/ProcessDisclosuresPage";
import PerformanceDisclosurePage from "./features/disclouser/sectionC/PerformanceDisclosurePage";
import SectionCDisclosuresPage from "./features/disclouser/sectionC/SectionCDisclosuresPage";
import BRSRWorkspace from "./features/disclouser/BRSRWorkspace/BRSRWorkspace";
import ViewBetails from "./features/disclouser/ViewAction";
import ViewCetails from "./features/disclouser/section_c_view";

/* INTERNAL REPORTS */
import CarbonPerformance from "./features/reports/CarbonPerformance/CarbonPerformance";
import EmissionTrends from "./features/reports/EmissionTrendsPage";
import ByDepartment from "./features/reports/ByDepartment/ByDepartment";
import ByLocationPage from "./features/reports/ByLocation/ByLocationPage";
import EnergyAnalysisPage from "./features/reports/EnergyAnalysis/EnergyAnalysisPage";
import CarbonPerformancePage from "./features/reports/CarbonPerformancePage";
import WaterAnalysisPage from "./features/reports/WaterAnalysisPage";
import WasteAnalysisPage from "./features/reports/WasteAnalysisPage";
import ComparisonAnalysisPage from "./features/reports/ComparisonAnalysisPage";
import ExecutiveDashboardPage from "./features/reports/ExecutiveDashbaordPage";
import EsgScorecardPage from "./features/reports/EsgScorecardPage";

/* SUPER ADMIN */
import SuperAdminLogin from "./superadmin/pages/LoginPage";
import SuperAdminDashboard from "./superadmin/pages/Dashboard";
import Organisations from "./superadmin/pages/Organisation";
import ManageActivity from "./superadmin/pages/ManageActivity";

/*ADMINISTRATOR */
import UserPage from "./features/administration/user/UserPage";
import RolesPermissionsPage from "./features/administration/rolesPermissions/RolesPermissionsPage";
import SingleRolePermissionPage from "./features/administration/rolesPermissions/SingleRolesPermissionsPage";

/* Audit & Evidence */
import AuditEvidencePage from "./features/audit & evidence/auditEvidence/AuditEvidencePage";

/* STYLES */
import "./styles/variables.css";
import "./styles/base/reset.css";
import "./styles/base/typography.css";
import "./styles/layout/layout.css";
import "./styles/layout/sidebar.css";
import "./styles/layout/header.css";
import "./styles/components/button.css";
import "./styles/components/table.css";
import "./styles/components/form.css";
import "./styles/components/modal.css";
import "./styles/components/dropdown.css";
import "./styles/pages/login.css";
import "./styles/pages/dashboard.css";
import "./styles/pages/organization.css";
import "./styles/pages/workflow.css";
import "./styles/pages/reports.css";
import "./styles/pages/admin.css";
import "./styles/utilities/spacing.css";
import "./styles/utilities/helpers.css";
import "./styles/pages/environment.css";
import "./styles/pages/rolesPermissions.css";
import "./styles/pages/auditEvidence.css";
import "./styles/pages/energyAnalysis.css";
import "./styles/pages/principleDashboard.css";
import "./styles/pages/siteLocation.css";
import "./styles/pages/user.css";
import "./styles/pages/waterSummary.css";
import "./styles/pages/principleView.css";
import "./styles/pages/generalDisclosures.css";
import "./styles/pages/processDisclosures.css";
import "./styles/pages/secC.css";
import "./styles/pages/reports.css";

export default function App() {
  const [user, setUser] = useState(() => {
    const stored = localStorage.getItem("user");
    return stored ? JSON.parse(stored) : null;
  });

  const storedAdmin = localStorage.getItem("admin_name");
  const [admin, setAdmin] = useState(
    storedAdmin && storedAdmin !== "null" ? storedAdmin : null
  );

  const handleAdminLogout = () => {
    localStorage.removeItem("admin_name");
    localStorage.removeItem("admin_token");
    setAdmin(null);
  };

  return (
    <ReportingYearProvider>
      <BrowserRouter>
        <Routes>
          {/* CUSTOMER LOGIN */}
          <Route
            path="/login"
            element={
              user ? (
                <Navigate to="/dashboard" replace />
              ) : (
                <LoginPage onLogin={(userData) => setUser(userData)} />
              )
            }
          />

          <Route path="/reset-password" element={<ResetPasswordPage />} />

          <Route
            path="/dashboard"
            element={
              user ? (
                <DashboardPage
                  user={user}
                  onLogout={() => {
                    localStorage.removeItem("user");
                    localStorage.removeItem("token");
                    setUser(null);
                  }}
                />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          >
            <Route index element={<DashboardHome />} />

            {/* ORGANIZATION */}
            <Route
              path="organization-profile"
              element={<OrganizationProfilePage />}
            />
            <Route path="department" element={<DepartmentPage />} />
            <Route path="legal-entities" element={<LegalEntitiesPage />} />
             <Route path="legal-entities/entity-form/:id" element={<EntityFormPage />} />

            <Route path="sites-locations" element={<SitesLocationsPage />} />
            <Route
              path="manage_reporting_year"
              element={<ManageReportingYear />}
            />
            <Route path="location_mapping" element={<LocationMapping />} />
            <Route path="activity_mapping" element={<ActivityMapping />} />
            <Route
              path="environmental_parameters"
              element={<EnvironmentalParametersPage />}
            />
            <Route
              path="parameter_mapping"
              element={<ParameterMappingPage />}
            />

            {/* BRSR */}
            <Route
              path="principle-dashboard"
              element={<PrincipleDashboardPage />}
            />

            <Route
              path="principle-view/:principleCode/:legalEntityId/:reportingYearId"
              element={<PrincipleViewPage />}
            />
            <Route
              path="/dashboard/principle-detail/:principleCode/:legalEntityId/:reportingYearId"
              element={<PrincipleFormPage />}
            />
            {/* ENVIRONMENT */}
            <Route path="scope1-emissions" element={<Scope1EmissionPage />} />
            <Route path="scope2-emissions" element={<Scope2EmissionPage />} />
            <Route
              path="environmental-summary"
              element={<EnvironmentalSummaryPage />}
            />
            <Route
              path="energy-consumption"
              element={<ActivityRecordsPage />}
            />
            {/*<Route path="record-activity" element={<RecordActivity />} />*/}
            <Route path="record-activity" element={<RecordActivityPage />} />
            <Route path="view-activity/:id" element={<ViewActivityPage />} />
            <Route path="edit-activity/:id" element={<EditActivityPage />} />
            <Route
              path="scope1-activity-listing"
              element={<Scope1ActivityListing />}
            />
            <Route
              path="scope2-activity-listing"
              element={<Scope2ActivityListing />}
            />
            <Route
              path="energy-breakdown-listing"
              element={<EnergyBreakdownListing />}
            />
            <Route
              path="emission-intensity-listing"
              element={<EmissionIntensityListing />}
            />
            <Route path="import" element={<Import />} />
            <Route path="import/reference" element={<ImportReferencePage />}/>
            <Route path="import-summary" element={<ImportSummary />} />

            <Route path="water-summary" element={<WaterSummaryPage />} />
            <Route
              path="water-recycled-details"
              element={<WaterRecycledDetails />}
            />
            <Route
              path="water-source-details"
              element={<WaterSourceDetails />}
            />
            <Route
              path="recycling-rate-details"
              element={<RecyclingRateDetails />}
            />
            <Route
              path="freshwater-details"
              element={<NetFreshwaterDetails />}
            />
            <Route
              path="effluent-details"
              element={<EffluentDischargeDetails />}
            />

            <Route path="waste-summary" element={<WasteSummaryPage />} />

            {/* Workflow & Approvals */}
            <Route path="submission-tracker" element={<SubmissionTracker />} />
            <Route path="review-screen" element={<ReviewScreen />} />
            <Route path="approval-lock" element={<ApprovalLock />} />
            <Route path="action-view/:principleCode/:legalEntityId/:reportingYearId/:submissionId" element={<ViewAction />} />

            {/* Disclosure Generator */}
            <Route path="disclosure-builder" element={<DisclosureBuilder />} />
            <Route path="export" element={<ExportScreen />} />

            <Route
              path="general-disclosures"
              element={<GeneralDisclosuresPage />}
            />
            <Route
              path="process-disclosures"
              element={<ProcessDisclosuresPage />}
            />
            {/* <Route path="section-b-view" element={<SectionbViewPage />} />  */}
            <Route path="section-c" element={<PerformanceDisclosurePage />} />
            <Route path="report-readiness" element={<BRSRWorkspace />} />
            <Route
              path="section-view/:section/:reportingYearId/:legalEntityId/:principleId"
              element={<ViewBetails />}
            />
            <Route
              path="section-view/C/:reportingYearId/:legalEntityId/:principleId"
              element={<ViewCetails />}
            />

            {/* Internal Reports*/}
            <Route path="carbon-performance" element={<CarbonPerformancePage />} />
            <Route path="emission-trends" element={<EmissionTrends />} />
            <Route path="by-department" element={<ByDepartment />} />
            <Route path="by-location" element={<ByLocationPage />} />
            <Route path="energy-analysis" element={<EnergyAnalysisPage />} />
            <Route path="water-analysis" element={<WaterAnalysisPage />} />
            <Route path="waste-analysis" element={<WasteAnalysisPage />} />
            <Route path="comparative-analysis" element={<ComparisonAnalysisPage />} />
            <Route path="executive-dashboard" element={<ExecutiveDashboardPage />} />
            <Route path="esg-scorecard" element={<EsgScorecardPage />} />
            {/* Audit & Evidence */}
            <Route path="audit-evidence" element={<AuditEvidencePage />} />

            {/* ADMINISTRATION */}
            <Route path="user" element={<UserPage />} />
            <Route
              path="roles-permissions"
              element={<RolesPermissionsPage />}
            />
             <Route path="roles/:roleId/permissions" element={<SingleRolePermissionPage />}/>
             
          </Route>
         
          {/* SUPER ADMIN LOGIN */}
          <Route
            path="/superadmin/login"
            element={
              admin ? (
                <Navigate to="/superadmin/dashboard" replace />
              ) : (
                <SuperAdminLogin onLogin={(name) => setAdmin(name)} />
              )
            }
          />

          {/* SUPER ADMIN DASHBOARD */}
          <Route
            path="/superadmin/dashboard"
            element={
              admin ? (
                <SuperAdminDashboard
                  adminName={admin}
                  onLogout={handleAdminLogout}
                />
              ) : (
                <Navigate to="/superadmin/login" replace />
              )
            }
          />

          {/* SUPER ADMIN DASHBOARD */}
          <Route
            path="/superadmin/dashboard"
            element={
              admin ? (
                <SuperAdminDashboard
                  adminName={admin}
                  onLogout={handleAdminLogout}
                />
              ) : (
                <Navigate to="/superadmin/login" replace />
              )
            }
          />

          {/* ORGANIZATION PAGE */}
          <Route
            path="/superadmin/organisations"
            element={
              admin ? (
                <Organisations adminName={admin} onLogout={handleAdminLogout} />
              ) : (
                <Navigate to="/superadmin/login" replace />
              )
            }
          />

          {/* ADMINISTRATION*/}

          <Route path="user" element={<UserPage />} />
          <Route path="roles-permissions" element={<RolesPermissionsPage />} />

          {/* DEFAULT */}
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="*" element={<Navigate to="/login" replace />} />

          {/* Manage Activity */}
          <Route
            path="/superadmin/manageactivity"
            element={
              admin ? (
                <ManageActivity
                  adminName={admin}
                  onLogout={handleAdminLogout}
                />
              ) : (
                <Navigate to="/superadmin/login" replace />
              )
            }
          />
        </Routes>
      </BrowserRouter>
    </ReportingYearProvider>
  );
}